import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import IntlMessages from '../utility/intlMessages';
import styles from './styles.module.scss';

interface IAccessDeniedModal {
  visible: boolean;
  onClose: () => void;
  statusCode: number;
}

export default function AccessDeniedModal({ visible, onClose, statusCode }: IAccessDeniedModal) {
  const getTitleId = () => {
    return statusCode === 401 
      ? 'error.accessDenied.unauthorized.title'
      : 'error.accessDenied.forbidden.title';
  };

  const getMessageId = () => {
    return statusCode === 401
      ? 'error.accessDenied.unauthorized.message'
      : 'error.accessDenied.forbidden.message';
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={400}
      centered
      destroyOnClose
    >
      <div className={styles.modalContentWrapper}>
        <div className={styles.iconTitleRow}>
          <span className={styles.errorIcon}>
            <ExclamationCircleOutlined />
          </span>
          <span className={styles.modalTitle}>
            <IntlMessages id={getTitleId()} />
          </span>
        </div>
        
        <div className={styles.messageRow}>
          <div className={styles.messageContent}>
            <p className={styles.messageText}>
              <IntlMessages id={getMessageId()} />
            </p>
          </div>
        </div>
        
   
      </div>
    </Modal>
  );
}
